jq2 = jQuery.noConflict();
jq2(function ($) {
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

    var initPhotoSwipeFromDOM = function (gallerySelector) {
        // parse slide data (url, title, size ...) from DOM elements
        // (children of gallerySelector)
        var parseThumbnailElements = function (el) {
            var thumbElements = el.childNodes,
                numNodes = thumbElements.length,
                items = [],
                figureEl,
                linkEl,
                size,
                item;

            for (var i = 0; i < numNodes; i++) {

                figureEl = thumbElements[i]; // <figure> element

                // include only element nodes
                if (figureEl.nodeType !== 1) {
                    continue;
                }

                linkEl = figureEl.children[0]; // <a> element

                size = linkEl.getAttribute('data-size').split('x');

                // create slide object
                item = {
                    src: linkEl.getAttribute('href'),
                    w: parseInt(size[0], 10),
                    h: parseInt(size[1], 10)
                };


                if (figureEl.children.length > 1) {
                    // <figcaption> content
                    item.title = figureEl.children[1].innerHTML;
                }

                if (linkEl.children.length > 0) {
                    // <img> thumbnail element, retrieving thumbnail url
                    item.msrc = linkEl.children[0].getAttribute('src');
                }

                item.el = figureEl; // save link to element for getThumbBoundsFn
                items.push(item);
            }

            return items;
        };

        // find nearest parent element
        var closest = function closest(el, fn) {
            return el && ( fn(el) ? el : closest(el.parentNode, fn) );
        };

        // triggers when user clicks on thumbnail
        var onThumbnailsClick = function (e) {
            e = e || window.event;
            e.preventDefault ? e.preventDefault() : e.returnValue = false;

            var eTarget = e.target || e.srcElement;

            // find root element of slide
            var clickedListItem = closest(eTarget, function (el) {
                return (el.tagName && el.tagName.toUpperCase() === 'FIGURE');
            });

            if (!clickedListItem) {
                return;
            }

            // find index of clicked item by looping through all child nodes
            // alternatively, you may define index via data- attribute
            var clickedGallery = clickedListItem.parentNode,
                childNodes = clickedListItem.parentNode.childNodes,
                numChildNodes = childNodes.length,
                nodeIndex = 0,
                index;

            for (var i = 0; i < numChildNodes; i++) {
                if (childNodes[i].nodeType !== 1) {
                    continue;
                }

                if (childNodes[i] === clickedListItem) {
                    index = nodeIndex;
                    break;
                }
                nodeIndex++;
            }


            if (index >= 0) {
                // open PhotoSwipe if valid index found
                openPhotoSwipe(index, clickedGallery);
            }
            return false;
        };

        // parse picture index and gallery index from URL (#&pid=1&gid=2)
        var photoswipeParseHash = function () {
            var hash = window.location.hash.substring(1),
                params = {};

            if (hash.length < 5) {
                return params;
            }

            var vars = hash.split('&');
            for (var i = 0; i < vars.length; i++) {
                if (!vars[i]) {
                    continue;
                }
                var pair = vars[i].split('=');
                if (pair.length < 2) {
                    continue;
                }
                params[pair[0]] = pair[1];
            }

            if (params.gid) {
                params.gid = parseInt(params.gid, 10);
            }

            return params;
        };

        var openPhotoSwipe = function (index, galleryElement, disableAnimation, fromURL) {
            var pswpElement = document.querySelectorAll('.pswp')[0],
                gallery,
                options,
                items;

            items = parseThumbnailElements(galleryElement);

            // define options (if needed)
            options = {

                // define gallery index (for URL)
                galleryUID: galleryElement.getAttribute('data-pswp-uid'),

                getThumbBoundsFn: function (index) {
                    // See Options -> getThumbBoundsFn section of documentation for more info
                    var thumbnail = items[index].el.getElementsByTagName('img')[0], // find thumbnail
                        pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
                        rect = thumbnail.getBoundingClientRect();

                    return {x: rect.left, y: rect.top + pageYScroll, w: rect.width};
                },
                shareEl: false,
                showHideOpacity: true,
                hideAnimationDuration: 0,
                showAnimationDuration: 0

            };

            // PhotoSwipe opened from URL
            if (fromURL) {
                if (options.galleryPIDs) {
                    // parse real index when custom PIDs are used
                    // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
                    for (var j = 0; j < items.length; j++) {
                        if (items[j].pid == index) {
                            options.index = j;
                            break;
                        }
                    }
                } else {
                    // in URL indexes start from 1
                    options.index = parseInt(index, 10) - 1;
                }
            } else {
                options.index = parseInt(index, 10);
            }

            // exit if index not found
            if (isNaN(options.index)) {
                return;
            }

            if (disableAnimation) {
                options.showAnimationDuration = 0;
            }

            // Pass data to PhotoSwipe and initialize it
            gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
            gallery.init();
        };

        // loop through all gallery elements and bind events
        var galleryElements = document.querySelectorAll(gallerySelector);

        for (var i = 0, l = galleryElements.length; i < l; i++) {
            galleryElements[i].setAttribute('data-pswp-uid', i + 1);
            galleryElements[i].onclick = onThumbnailsClick;
        }

        // Parse URL and open gallery if it contains #&pid=3&gid=1
        var hashData = photoswipeParseHash();
        if (hashData.pid && hashData.gid) {
            openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
        }
    };

// execute above function
    initPhotoSwipeFromDOM('.advert__single--gallery');

    var categories, subcategories, subsubcategories = [];

    var generateOptions = function (obj) {
        var options = '<option value="">'+vars.choose+'</option>';
        var other = '';
        $.each(obj, function (id, category) {
            if(id == 87 || id == 302)
                other += '<option value="' + id.trim() + '">' + category.name + '</option>';
            else
                options += '<option value="' + id.trim() + '">' + category.name + '</option>';
        });
        if(other.length > 5)
            options += other;
        return options;
    };

    var getSpecifications = function (id) {
        $.ajax({
            url: vars.url.getSpecifications,
            data: {category: id},
            method: 'POST',
            dataType: 'html',
            success: function (response) {
                $('#specifications').html(response);
            }
        });
    };

    var getMakes = function (id) {
        $.ajax({
            url: vars.url.getMakes,
            data: {category: id},
            method: 'POST',
            dataType: 'json',
            beforeSend: function () {
                $('select#makes_list').html('');
            },
            success: function (response) {
                var options = '<option value="">' + vars.placeholders.select + '</options>';
                $.each(response, function (id, make) {
                    options += '<option value="' + (make.id) + '">' + make.make_name + '</option>';
                });
                $('select#makes_list').html(options);
            },
            error: function (responce) {
                var options = '<option value="">' + vars.placeholders.select + '</options>';
                $('select#makes_list').html(options);
            }
        });
    };

    $(document).on('change', 'select#subsubcategory_id', function () {
        //if($(this).closest('form').data('required'))
        console.log($(this).closest('form').data('required'));

        var id = $(this).val();
        if(id == 0)
            id = '';
        var fromto = 0;
        if (!!$(this).data('get')) {
            if(id && id != '')
                getMakes(id);
            else
                getMakes($('select#subcategory_id').val())
        }
        if (!!$(this).data('fromto')) {
            fromto = 1;
        }
        $.ajax({
            url: vars.url.getMainFields,
            data: {category: id, fromto: fromto, required: $(this).closest('form').data('required') },
            method: 'POST',
            dataType: 'html',
            success: function (response) {
                $('#main-fields').html(response);
                if ($('input[name="type"][checked="checked"]').val() == 2) {
                    $('#price_input').hide();
                    $('.rent_prices').show();
                }
                else {
                    $('#price_input').show();
                    $('.rent_prices').hide();
                }

            }
        });
        getSpecifications(id);
    });

    $(document).on('change', 'select#subcategory_id', function () {
        if ($(this).val() != '') {
            subsubcategories = subcategories[' ' + $(this).val()]['children'];
            var placeholder = '';
            // if (parseInt($(this).data('placeholder')) == 1) {
            //     placeholder = '<option value="">' + vars.placeholders.select + '</options>';
            // }
            var options = placeholder;
            options += generateOptions(subsubcategories);
            $('select#subsubcategory_id').html(options).change();
        } else {
            $('select#subsubcategory_id').html('<option value>' + vars.placeholders.select + '</options>');
        }
    });
    $(document).on('change', 'select#category_id', function () {
        if ($(this).val() != '') {
            subcategories = categories[' ' + $(this).val()]['children'];
            var options = '';
            options += generateOptions(subcategories);
            $('select#subcategory_id').html(options).change();
            $('select#subsubcategory_id').html('<option value="0">' + vars.placeholders.select + '</options>');
            $('select#subsubcategory_id').change();
        } else {
            $('select#subcategory_id').html('<option value>' + vars.placeholders.select + '</options>').change();
        }
        // $(this).trigger('change');
    });

    var initCategoriesOptionsByType = function (type) {
        console.log('init categories');

        var params;
        if(URI.parse(window.location.href).query) {
            params = URI.parseQuery('?'+window.location.href.substring(window.location.href.indexOf('?') + 1, window.location.href.length));
        } else {
            params = [];
        }

        if(params.type){
            type = params.type;
        }

        // if(searchParams.category_id){
        //     var categories = searchParams.category_id.split(',');
        //     if(categories[0]){
        //         console.log(categories[0]);
        //         $('#category_id').val(categories[0]);
        //     }
        //     console.log(categories);
        // }


        $.ajax({
            url: vars.url.getCategories,
            data: {type: type},
            method: 'POST',
            dataType: 'json',
            success: function (response) {
                categories = response;
                subcategories, subsubcategories = [];
                var options = generateOptions(response);
                $('select#category_id').html(options).change();

                if(params.category){
                    console.log(params.category);
                    $('#category_id').val(params.category).change();
                    if(params.category_id){
                        var cats = params.category_id.split(',');
                        if(cats[0] && cats[0] != 0){
                            $('#subcategory_id').val(cats[0]).change();
                            if(cats[1] && cats[1] != 0){
                                $('#subsubcategory_id').val(cats[1]).change();
                                setTimeout(function() {
                                    if (params.make_id) {
                                        $('select[name="make_id"]').val(params.make_id);
                                    }

                                    if (params.country_id) {
                                        $('select[name="country_id"]').val(params.country_id);
                                    }

                                    if (params.year) {
                                        var years = params.year.split(',');
                                        if(years[0] != 0)
                                            $('select[name="year[]"]:first').val(years[0]);
                                        if(years[1] != 0)
                                            $('select[name="year[]"]:last').val(years[1]);
                                    }

                                    if (params.price) {
                                        var price = params.price.split(',');
                                            $('input[name="price[]"]:first').val(price[0]);
                                        if(price[1] != 0)
                                            $('input[name="price[]"]:last').val(price[1]);
                                    }

                                }, 1000);
                            }
                        }
                    }
                }
            }
        });
        // $('select#subcategory_id').html('<option value>' + vars.placeholders.select + '</options>').change();
    };

    if ($('.create__radio--single.disabled').length == 0) {
        initCategoriesOptionsByType(1);
    }

    $(this).on('click', '.create__radio--single:not(.disabled)', function () {
        $('.create__radio--single').removeClass('active').find('input[type="radio"]').removeAttr('checked');
        $(this).addClass('active').find('input[type="radio"]').attr('checked', 'checked');
        if($(this).parent().parent().is('a')){
            window.location.href = $(this).parent().parent().prop('href');
        } else {
            initCategoriesOptionsByType(parseInt($(this).find('input[type="radio"]').val()));
        }
    });

    $(this).on('click', 'a[data-type]', function () {
        $('input[name="type"]').val($(this).data('type'));
        initCategoriesOptionsByType($(this).data('type'));
    });

    $(this).on('change', 'input[name="f_746261"]', function () {
        if ($(this).prop('checked')) {
            $('input[name="price"]').attr('disabled', 'disabled');
        }
        else {
            $('input[name="price"]').removeAttr('disabled');
        }
    });

    $('.button-collapse').sideNav({
        menuWidth: 300, // Default is 300
        edge: 'right', // Choose the horizontal origin
        closeOnClick: true, // Closes side-nav on <a> clicks, useful for Angular/Meteor
        draggable: true // Choose whether you can drag to open on touch screens
    });

    $('.mobile__nav--close').click(function () {
        $('.button-collapse').sideNav('hide');
    });

    $('.advert__single--gallery').on('init', function () {
        $(this).find('.item').removeClass('hidden');
    });

    $('.advert__single--gallery').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.advert__single--thumbs ul',
        slide: 'figure',
        prevArrow: $('.advert__single--prev'),
        nextArrow: $('.advert__single--next')
    });
    $('.advert__single--thumbs ul').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: '.advert__single--gallery',
        dots: false,
        centerMode: false,
        focusOnSelect: true,
        slide: 'li',
        prevArrow: $('.advert__single--prev'),
        nextArrow: $('.advert__single--next')
    });

    var collapseButton = function (el, collapsible, toggle) {
        el.find('i').toggleClass('fa-caret-down').toggleClass('fa-caret-up');
        collapsible.toggleClass(toggle);
    };
    $('#collapseCategoriesButton').click(function () {
        collapseButton($(this), $('#collapseCategories'), 'visible-lg');
    });

    $('#collapseFiltersButton').click(function () {
        collapseButton($(this), $('.advert__results--filter'), 'hidden-xs');
    });

    $('.quick__search--button > button').removeAttr('disabled');

});